
  import { Vue, Component, Prop } from "vue-property-decorator";

  import ContractorsDocumentsFilteredList from "@/components/documents/ContractorsDocumentsFilteredList.vue";

  import { Company, User } from "@/generated/graphql";

  @Component({
    components: {
      ContractorsDocumentsFilteredList,
    },
  })
  export default class DocumentsManagerContractors extends Vue {
    @Prop({ type: Object, required: true }) readonly company!: Company;
    @Prop({ type: Object, required: true }) readonly currentUser!: User;

    get queryObject() {
      return {
        "company_id": { "_eq": this.company.id },
      };
    }
  }
